<template lang="pug">
.cadastro-telefones
  .cadastro-telefones__input-row
    input.cadastro-telefones__input(
      type="text"
      :value="value"
      :placeholder="placeholder"
      :disabled="disabled"
      v-mask="['(##) #####-####', '(##) ####-####']"
      @input="$emit('input', $event.target.value)"
      @keyup.enter="adicionar"
    )
    button.cadastro-telefones__add(
      type="button"
      :disabled="!podeAdicionar"
      @click="adicionar"
    )
      img(src="@/assets/icons/cadastro/plus.svg" alt="Adicionar telefone")

  .cadastro-telefones__tags(v-if="telefones.length")
    .cadastro-telefones__tag(v-for="(telefone, index) in telefones" :key="index")
      span {{ telefone }}
      button.cadastro-telefones__remove(type="button" @click="$emit('remove', telefone)")
        img(src="@/assets/icons/cadastro/x.svg" alt="Remover")

  span.cadastro-telefones__error(v-if="error") {{ error }}
</template>

<script>
export default {
  name: 'CadastroTelefonesInput',
  props: {
    value: {
      type: String,
      default: ''
    },
    telefones: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      default: ''
    }
  },
  computed: {
    placeholder () {
      return this.telefones.length >= 3 ? 'Máximo de 3 telefones' : '(__) _____-____'
    },
    podeAdicionar () {
      return !this.disabled && this.value.length >= 14 && this.telefones.length < 3
    }
  },
  methods: {
    adicionar () {
      if (this.podeAdicionar) {
        this.$emit('add', this.value)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.cadastro-telefones__input-row {
  display: flex;
  width: 100%;
}

.cadastro-telefones__input {
  background: #ffffff;
  border: 1px solid #eaeaea;
  border-radius: 8px 0 0 8px;
  color: #141414;
  flex: 1;
  font-family: 'Inter', 'Ubuntu', sans-serif;
  font-size: 14px;
  height: 40px;
  padding: 4px 12px;

  &::placeholder {
    color: #8a8a8a;
    opacity: 0.5;
  }

  &:focus {
    border-color: #1e174e;
    outline: none;
  }
}

.cadastro-telefones__add {
  align-items: center;
  background: #ffffff;
  border: 1px solid #eaeaea;
  border-left: 0;
  border-radius: 0 8px 8px 0;
  cursor: pointer;
  display: flex;
  height: 40px;
  justify-content: center;
  width: 40px;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  img {
    height: 16px;
    width: 16px;
  }
}

.cadastro-telefones__tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
}

.cadastro-telefones__tag {
  align-items: center;
  background: #ffffff;
  border: 1px solid #eaeaea;
  border-radius: 8px;
  color: #8a8a8a;
  display: inline-flex;
  font-family: 'Inter', 'Ubuntu', sans-serif;
  font-size: 12px;
  gap: 8px;
  padding: 8px 10px;
}

.cadastro-telefones__remove {
  align-items: center;
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  padding: 0;

  img {
    height: 12px;
    width: 12px;
  }
}

.cadastro-telefones__error {
  color: #ef4444;
  display: block;
  font-family: 'Inter', 'Ubuntu', sans-serif;
  font-size: 12px;
  margin-top: 4px;
}
</style>
